import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { OnboardingProvider, useOnboarding } from "@/context/OnboardingContext";
import StandardWizard from "@/pages/onboarding/StandardWizard";
import ProWizard from "@/pages/onboarding/ProWizard";

const InnerRouter = () => {
  const { user } = useAuth();
  const { loaded, completed } = useOnboarding();
  if (!loaded) return null;
  if (completed) return <Navigate to="/dashboard" replace />;
  return user?.account_type === "pro" ? <ProWizard /> : <StandardWizard />;
};

const OnboardingRoot = () => {
  const { isAuthenticated, booting } = useAuth();
  if (booting) return null;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  return (
    <OnboardingProvider>
      <InnerRouter />
    </OnboardingProvider>
  );
};

export default OnboardingRoot;
